<template>
  <AtlasButton
    ref="target"
    :title="t('Save')"
    class="secondary"
    :class="{ active: articleBookmark.bookmarked.value }"
    :icon="articleBookmark.bookmarked.value ? 'common/heart-filled' : 'common/heart'"
    @click="toggleBookmarkOnClick"
  />
</template>
<script setup lang="ts">
import { useElementVisibility } from '@vueuse/core';
import { AtlasButton } from '@nhst/ui';
const { t } = useI18n();

const props = defineProps({
  articleId: {
    type: String,
    required: true
  }
});
const target = ref(null);
const componentHasVisited = ref(false);
const componentIsVisible = useElementVisibility(target);

const articleBookmark = useArticleBookmark();
const toggleBookmarkOnClick = () => {
  articleBookmark.toggleBookmark(props.articleId);
};

watch(
  () => componentIsVisible.value,
  () => {
    if (componentIsVisible.value && !componentHasVisited.value) {
      articleBookmark.checkBookmark(props.articleId);
      componentHasVisited.value = true;
    }
  },
  { immediate: false }
);
</script>

<style lang="scss" scoped>
.atlas-button {
  &.active {
    --atlas-icon_color: var(--color-utility-success-dark);
  }
}
</style>
